import React from 'react';

import {QuoteImage} from 'src/components/editorial/QuoteImage';

import {SanityQuote} from 'types/generated';

export const EditorialQuote: React.FC<SanityQuote> = props => {
  return (
    <div>
      {props.quoteOptions === 'quoteImage' && props.quoteImage && (
        <section className="py-4 lg:py-8" data-module="pull-quote-with-image">
          <div className="wrapper-default grid grid-cols-4 md:grid-cols-12 gap-x-8 gap-y-12">
            <div className="col-span-full md:col-span-6 md:order-last">
              <QuoteImage {...props.quoteImage} />
              <p className="type-xs-p mt-2">{props.quoteImage?.caption}</p>
            </div>
            <div className="col-span-full md:col-span-6 border-l-4 border-dark-gold md:py-3">
              <div className="type-eta text-dark-gold ml-8 lg:ml-10 relative before:content-['“'] before:absolute before:-left-[0.60rem] lg:before:-left-4 before:type-theta before:!text-[35px} lg:before:text-[25px] after:content-['”'] after:absolute after:type-theta lg:after:text-[25px]">
                {props.body}
              </div>
              {props.attribution && (
                <span className="block text-gray type-sm-p mt-3 md:mt-4 ml-8 md:ml-10">- {props.attribution}</span>
              )}
            </div>
          </div>
        </section>
      )}

      {props.quoteOptions === 'quote' && (
        <section className="py-4 lg:py-8" data-module="pull-quote-full">
          <div className="wrapper-default grid grid-cols-4 md:grid-cols-12 gap-x-8">
            <div className="border-l-4 border-dark-gold md:py-4 col-span-full md:col-span-full">
              <div className="ml-6 lg:ml-11 type-eta md:type-delta !text-dark-gold relative before:content-['“'] before:absolute before:-left-[0.60rem] lg:before:-left-4 before:type-theta before:!text-[35px} lg:before:text-[25px] after:content-['”'] after:absolute after:type-theta lg:after:text-[25px]">
                {props.body}
              </div>
              {props.attribution && (
                <span className="ml-6 lg:ml-11 mt-4 md:mt-5 block text-gray type-sm-p md:type-p">
                  – {props.attribution}
                </span>
              )}
            </div>
          </div>
        </section>
      )}

      {props.quoteOptions === 'pullQuoteImage' && (
        <section className="w-full md:w-1/2 md:mr-8 md:float-left pb-8 relative mb-4" data-module="image-w-quote">
          <div className="w-full relative z-20">
            <div>
              <QuoteImage {...props.quoteImage} />
              <div className="type-xs-p mt-2">{props.quoteImage?.caption}</div>
            </div>

            {props.body && (
              <div className="mt-7 border-l-4 border-dark-gold md:py-1">
                <div className="type-theta text-dark-gold ml-8 lg:ml-10 relative">
                  <p
                    className="before:content-['“'] before:absolute before:-left-[0.60rem] 
                    lg:before:-left-4 before:type-theta lg:before:text-[25px] 
                    after:content-['”'] after:absolute after:type-theta lg:after:text-[25px]"
                  >
                    {props.body}
                  </p>
                </div>
                {!!props.attribution && (
                  <span className="block type-sm-p mt-3 ml-8 md:ml-10 text-gray ">- {props.attribution}</span>
                )}
              </div>
            )}
          </div>
        </section>
      )}
    </div>
  );
};
